import React, { useEffect, useState } from "react";
import AddSellSystemLead from "./addSellSystemLead.js";
import SellSystemCalendar from "./sellSystemCalendar.js";
import SellSystemDashboard from "./sellSystemDashboard.js";
import SellSystemLeadsDocs from "./sellSystemDocs.js";
import SellSystemLeads from "./sellSystemLeads.js";
import SellSystemLeadsArchive from "./sellSystemLeadsArchive.js";
import SellSystemLeadsArchiveSKD from "./sellSystemLeadsArchiveSKD.js";
import SellSystemLeadsFinish from "./sellSystemLeadsFinish.js";
import SellSystemLeadsNon from "./sellSystemLeadsNon.js";
import SellSystemLeadsReklamation from "./sellSystemLeadsReklamation.js";
import SellSystemLeadsSearch from "./sellSystemLeadsSearch.js";
import SellSystemLeadsSearchNote from "./sellSystemLeadsSearchNote.js";
import Loading from "../helpers/loading_component.js";
import SellSystemLeadsConSkd from "./sellSystemConSKD.js";

const SellSystem = (props) => {
  const [showLeads, setShowLeads] = useState(false);
  const [showLeadsConSKD, setShowLeadsConSKD] = useState(false);
  const [showLeadsNon, setShowLeadsNon] = useState(false);
  const [showLeadsDocs, setShowLeadsDocs] = useState(false);
  const [showLeadsArchive, setShowLeadsArchive] = useState(false);
  const [showLeadsArchiveSKD, setShowLeadsArchiveSKD] = useState(false);
  const [showLeadsReklamation, setShowLeadsReklamation] = useState(false);
  const [showLeadsFinish, setShowLeadsFinish] = useState(false);
  const [showLeadsSearch, setShowLeadsSearch] = useState(false);
  const [showLeadsSearchNote, setShowLeadsSearchNote] = useState(false);
  const [showLeadsDashboard, setShowLeadsDashboard] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showAddLead, setShowAddLead] = useState(false);
  const [loading, setLoading] = useState(true);
  const [inside, setInside] = useState(false);

  useEffect(() => {
    if (props.user.role === "consultantTele" && !inside) {
      if (props.calendar === true) {
        closeLeadsF();
        closeCalendarF();
        setShowCalendar(true);
        setShowLeads(false);
      }

      if (props.contacts === true) {
        closeLeadsF();
        closeCalendarF();
        setShowLeads(true);
        setShowCalendar(false);
      }
    }

    setLoading(false);
  });

  const showLeadsF = () => {
    setShowLeads(true);
    setShowLeadsNon(false);
    setShowCalendar(false);
    setShowLeadsDocs(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showLeadsNonF = () => {
    setShowLeads(false);
    setShowLeadsNon(true);
    setShowLeadsDocs(false);
    setShowCalendar(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showLeadsDocsF = () => {
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowLeadsDocs(true);
    setShowCalendar(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const closeLeadsF = () => {
    setShowLeads(false);
  };

  const closeLeadsnonF = () => {
    setShowLeadsNon(false);
  };

  const closeLeadsDocsF = () => {
    setShowLeadsDocs(false);
  };

  const showLeadsArchiveF = () => {
    setShowLeads(false);
    setShowLeadsDocs(false);
    setShowLeadsNon(false);
    setShowCalendar(false);
    setShowAddLead(false);
    setShowLeadsArchive(true);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showLeadsReklamationF = () => {
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowLeadsDocs(false);
    setShowCalendar(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(true);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showLeadsFinishF = () => {
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowLeadsDocs(false);
    setShowCalendar(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(true);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showLeadsSearchF = () => {
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowLeadsDocs(false);
    setShowCalendar(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(true);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const closeLeadsArchiveF = () => {
    setShowLeadsArchive(false);
  };

  const closeLeadsReklamationF = () => {
    setShowLeadsReklamation(false);
  };

  const closeLeadsFinishF = () => {
    setShowLeadsFinish(false);
  };

  const closeLeadsSearchF = () => {
    setShowLeadsSearch(false);
  };

  const showCalendarF = () => {
    setShowCalendar(true);
    setShowLeadsNon(false);
    setShowLeads(false);
    setShowLeadsDocs(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showAddLeadF = () => {
    setShowCalendar(false);
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowAddLead(true);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDocs(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const closeCalendarF = () => {
    setShowCalendar(false);
  };

  const showLeadsArchiveSKDF = () => {
    setShowCalendar(false);
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsArchiveSKD(true);
    setShowLeadsDocs(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const closeLeadsArchiveSKDF = () => {
    setShowLeadsArchiveSKD(false);
  };

  const showLeadsSearchNoteF = () => {
    setShowCalendar(false);
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(true);
    setShowLeadsDocs(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const closeLeadsSearchNoteF = () => {
    setShowLeadsSearchNote(false);
  };

  const showLeadsDashboardF = () => {
    setShowCalendar(false);
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsDocs(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(true);
    setShowLeadsConSKD(false);
    setInside(true);
  };

  const showLeadsConSKDF = () => {
    setShowCalendar(false);
    setShowLeads(false);
    setShowLeadsNon(false);
    setShowAddLead(false);
    setShowLeadsArchive(false);
    setShowLeadsReklamation(false);
    setShowLeadsFinish(false);
    setShowLeadsSearch(false);
    setShowLeadsSearchNote(false);
    setShowLeadsDocs(false);
    setShowLeadsArchiveSKD(false);
    setShowLeadsDashboard(false);
    setShowLeadsConSKD(true);
    setInside(true);
  };

  const closeLeadsDashboardF = () => {
    setShowLeadsDashboard(false);
  };

  const closeLeadsConSKDF = () => {
    setShowLeadsConSKD(false);
  };

  const closeAddLeadF = () => {
    setShowAddLead(false);
  };

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>

        <div className="paymentMenuContainer">
          {props.user.adminSprzedaz === "1" ? (
            <button className="paymentMenuButton" onClick={showLeadsDashboardF}>
              DASHBOARD
            </button>
          ) : (
            ""
          )}

          {props.user.role === "consultantTele" ? (
            <button className="paymentMenuButton" onClick={showLeadsConSKDF}>
              KONTAKTY OFERTOWE
            </button>
          ) : (
            ""
          )}

          <button className="paymentMenuButton" onClick={showLeadsF}>
            KONTAKTY PROCEDOWANE
          </button>

          {props.user.role === "consultantTele" ? (
            <button className="paymentMenuButton" onClick={showLeadsNonF}>
              KONTAKTY NIEPROCEDOWANE
            </button>
          ) : (
            ""
          )}

          {props.user.role === "consultantTele" ? (
            <button className="paymentMenuButton" onClick={showLeadsDocsF}>
              DOKUMENTY DO UZUPEŁNIENIA
            </button>
          ) : (
            ""
          )}

          {props.user.role === "consultantTele" ? (
            <button
              className="paymentMenuButton"
              onClick={showLeadsArchiveSKDF}
            >
              KONTAKTY ARCHIWALNE SKD
            </button>
          ) : (
            ""
          )}

          {props.user.role === "consultantTele" ? (
            <button className="paymentMenuButton" onClick={showLeadsSearchF}>
              WYSZUKIWARKA KONTAKTÓW
            </button>
          ) : (
            ""
          )}

          <button className="paymentMenuButton" onClick={showCalendarF}>
            KALENDARZ
          </button>
          {props.user.role === "consultantTele" ||
          props.user.role === "consultantTeleSKD" ? (
            ""
          ) : (
            <>
              <button className="paymentMenuButton" onClick={showAddLeadF}>
                DODAJ KONTAKT
              </button>

              <button className="paymentMenuButton" onClick={showLeadsArchiveF}>
                KONTAKTY ARCHIWALNE
              </button>

              {props.user.adminSprzedaz === "1" ? (
                <>
                  <button
                    className="paymentMenuButton"
                    onClick={showLeadsReklamationF}
                  >
                    REKLAMACJE
                  </button>
                </>
              ) : (
                ""
              )}
            </>
          )}
          {props.user.role !== "consultantTele" ? (
            <button
              className="paymentMenuButton"
              onClick={showLeadsSearchNoteF}
            >
              SZUKAJ PO NOTATKACH/KONTAKTACH
            </button>
          ) : (
            ""
          )}
        </div>
        {loading ? (
          <>
            {" "}
            <Loading />
          </>
        ) : (
          <>
            {showCalendar ? (
              <>
                <SellSystemCalendar
                  close={closeCalendarF}
                  checkPermissions={props.checkPermissions}
                  date={props.date}
                  setDate={props.setDate}
                  logLeadAction={props.logLeadAction}
                  user={props.user.name}
                  team={props.team}
                  uData={props.user}
                  userCalendar={""}
                />
              </>
            ) : (
              ""
            )}

            {(showLeads && !showCalendar) ||
            (!showCalendar &&
              !showLeads &&
              !showLeadsNon &&
              !showLeadsDocs &&
              !showAddLead &&
              !showLeadsArchive &&
              !showLeadsReklamation &&
              !showLeadsFinish &&
              !showLeadsSearch &&
              !showLeadsSearchNote &&
              !showLeadsArchiveSKD &&
              !showLeadsDashboard &&
              !showLeadsConSKD) ? (
              <>
                <SellSystemLeads
                  close={closeLeadsF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsConSKD ? (
              <>
                <SellSystemLeadsConSkd
                  close={closeLeadsConSKDF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsSearch ? (
              <>
                <SellSystemLeadsSearch
                  close={closeLeadsSearchF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsDashboard ? (
              <>
                <SellSystemDashboard
                  close={closeLeadsDashboardF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsSearchNote ? (
              <>
                <SellSystemLeadsSearchNote
                  close={closeLeadsSearchNoteF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsNon ? (
              <>
                <SellSystemLeadsNon
                  close={closeLeadsnonF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsDocs ? (
              <>
                <SellSystemLeadsDocs
                  close={closeLeadsDocsF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsArchive ? (
              <>
                <SellSystemLeadsArchive
                  close={closeLeadsArchiveF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsArchiveSKD ? (
              <>
                <SellSystemLeadsArchiveSKD
                  close={closeLeadsArchiveSKDF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsReklamation ? (
              <>
                <SellSystemLeadsReklamation
                  close={closeLeadsReklamationF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showLeadsFinish ? (
              <>
                <SellSystemLeadsFinish
                  close={closeLeadsFinishF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                  logLeadAction={props.logLeadAction}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : (
              ""
            )}

            {showAddLead ? (
              <>
                <AddSellSystemLead
                  close={closeAddLeadF}
                  checkPermissions={props.checkPermissions}
                  user={props.user}
                />
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SellSystem;
